import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

const FineBannar = () => {
    return (
        <>
            <div className='dfl_fine_jwelery_banner'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row>
                        <Col sm={12} md={6} lg={6}>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                            <div className='banner_cotntent'>
                                <h1>Fine <br /> <span>jewelry </span></h1>
                                <p>We have a breathtaking collection of diamond and gemstone fine jewelry. Each piece is created with great precision and craftsmanship to make you feel special.</p>
                                <NavLink to="/jewelry/fine-jewelry">Shop jewelry </NavLink>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default FineBannar